import { Button, Flex, Grid, Heading, IconButton, Select } from '@radix-ui/themes'
import React, { useState } from 'react'
import RoomCard from '../components/ui-components/RoomCard'
import SearchableDropdown from '../components/ui-components/SearchableDropdown'
import { BiSearch } from 'react-icons/bi'
import ResetView from '../components/ui-components/ResetView'

const MyPatientsPage = () => {
    const [selectedDepartment, setSelectedDepartment] = useState("department1");
    const [functionalRoomData, setFunctionalRoomData] = useState(
        {
            "room_id": "1203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "wake_up": false,
            "isDischarge": false
        },
    )

    const departments = [
        { id: "department1", name: "Department 1" },
        { id: "department2", name: "Department 2" },
        { id: "department3", name: "Department 3" },
        { id: "department4", name: "Department 4" },
        { id: "department5", name: "Department 5" }
    ];

    const roomData1 = [
        {
            "room_id": "1201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
       {
            "room_id": "1202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
        {
            "room_id": "1204",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1205",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1206",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1207",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1208",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1209",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1210",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "1203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
    ];

    const roomData2 = [
        {
            "room_id": "2201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
       {
            "room_id": "2202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
        {
            "room_id": "2204",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2205",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2206",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2207",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2208",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2209",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2210",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "2203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
    ];
    

    const roomData3 = [
        
        {
            "room_id": "3201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
       {
            "room_id": "3202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
        {
            "room_id": "3204",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3205",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3206",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3207",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3208",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3209",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3210",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "3203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
    ];

    const roomData4 = [
        {
            "room_id": "4201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
       {
            "room_id": "4202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
        {
            "room_id": "4204",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4205",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4206",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4207",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4208",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4209",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4210",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "4203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
    ];

    const roomsData5 = [
        {
            "room_id": "5201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
       {
            "room_id": "5202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": false
        },
        {
            "room_id": "5204",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5205",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5206",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5207",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5208",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5209",
            "diaper": "red",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5210",
            "diaper": "green",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5201",
            "diaper": "green",
            "medication": "green",
            "room_stat": "blue",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5202",
            "diaper": "orange",
            "medication": "green",
            "room_stat": "green",
            "nurse_calling": "grey",
            "rolling": "green",
            "awake": "green",
            "isDischarge": true
        },
        {
            "room_id": "5203",
            "diaper": "red",
            "medication": "green",
            "room_stat": "orange",
            "nurse_calling": "green",
            "rolling": "grey",
            "awake": "green",
            "isDischarge": true
        },
    ];

    const departmentRoomDataMap = {
        department1: roomData1,
        department2: roomData2,
        department3: roomData3,
        department4: roomData4,
        department5: roomsData5,
    };

    const handleDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
    };

    const selectedRoomData = departmentRoomDataMap[selectedDepartment];

    return (
        <Flex direction={'column'} gap={'3'}>
        <Select.Root value={selectedDepartment} onValueChange={setSelectedDepartment}>
            <Select.Trigger />
            <Select.Content>
                {departments.map((dept) => (
                    <Select.Item key={dept.id} value={dept.id} className="font-bold">
                        <b>{dept.name}</b>
                    </Select.Item>
                ))}
            </Select.Content>
        </Select.Root>

        <Grid columns={{ initial: '1', xs: '2', sm: '2', md: '3', lg: '4' }} gap="4" width="100%">
            {selectedRoomData.map((room) => (
                <RoomCard key={room.room_id} data={room} />
            ))}
        </Grid>
    </Flex>
    )
}

export default MyPatientsPage